module.exports = __webpack_public_path__ + "assets/img/thumb-FormPiper-Landing-Page-+-Website.b452c3b5.webp";